import React from 'react';

const MobileFilterModal = ({ open, onClose, onCancel, onApply, children }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-40">
      {/* Drawer panel */}
      <div className="w-full max-w-md mx-auto bg-gray-50 rounded-lg shadow-lg animate-slideUp relative min-h-[60vh] flex flex-col">
        {/* Top bar */}
        <div className="flex items-center justify-between px-2 py-0.5 border-b border-gray-100">
          <span className="font-semibold text-base">Filter Resources</span>
          <button
            onClick={onClose}
            className="text-gray-600 text-2xl w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
            aria-label="Close filter panel"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        {/* Content area */}
        <div className="flex-1 overflow-y-auto p-2">
          {children || <div className="text-gray-400 text-center mt-8">Filter content goes here</div>}
        </div>
        {/* Bottom bar */}
        <div className="sticky bottom-0 left-0 w-full bg-white border-t border-gray-200 px-2 py-1.5 flex gap-2 justify-between z-10 shadow-md rounded-t-lg">
          <button
            onClick={onCancel || onClose}
            className="flex-1 py-1.5 rounded-full bg-gray-100 text-gray-700 font-medium text-sm hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
          >
            Cancel
          </button>
          <button
            onClick={onApply}
            className="flex-1 py-1.5 rounded-full bg-blue-600 text-white font-semibold text-sm hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
          >
            Apply Filters
          </button>
        </div>
      </div>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .animate-slideUp {
          animation: slideUp 0.25s cubic-bezier(0.4,0,0.2,1);
        }
      `}</style>
    </div>
  );
};

export default MobileFilterModal; 